import { Controller } from "@hotwired/stimulus"

// Controller that adds auto-submit to all form fields within account_data
// Only affects the specific form where this controller is attached
export default class extends Controller {
  connect() {
    // Wait a bit for all fields to be rendered (especially dynamic ones)
    setTimeout(() => {
      this.enableAutoSubmit()
    }, 100)

    // Also listen for turbo:frame-load to handle dynamic content
    this.element.addEventListener('turbo:frame-load', () => {
      setTimeout(() => {
        this.enableAutoSubmit()
      }, 100)
    })
  }

  enableAutoSubmit() {
    // Find all input, select, and textarea elements within this container
    // that don't already have auto-submit enabled
    const inputs = this.element.querySelectorAll(
      'input:not([data-action*="auto-submit#submit"]):not([type="hidden"]), ' +
      'select:not([data-action*="auto-submit#submit"]), ' +
      'textarea:not([data-action*="auto-submit#submit"])'
    )

    inputs.forEach(input => {
      // Skip hidden fields that are used by tagify or code-editor
      // (they already have auto-submit via their own hidden fields)
      if (input.type === 'hidden') {
        const isTagifyField = input.closest('.tagify-parent-wrapper')
        const isCodeEditorField = input.closest('[data-controller*="code-editor"]')
        if (isTagifyField || isCodeEditorField) {
          return
        }
      }

      // Add auto-submit action
      const existingAction = input.getAttribute('data-action') || ''
      const newAction = existingAction
        ? `${existingAction} auto-submit#submit`
        : 'auto-submit#submit'
      input.setAttribute('data-action', newAction)
    })
  }
}
